module.exports = __webpack_public_path__ + "static/media/mainLogo.b52b74cd.png";